import { QUERY_KEYS } from '../../../../../consts';
import { updateQuoteService } from '../../../../../services';
import { getAtomWithMutation } from '../../../../../utils';

export const updateQuoteAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.QUOTES.UPDATE_QUOTE_PAYMENT_TYPE,
  mutationFn: () => updateQuoteService,
});
